import * as React from "react";
import { SwanPublicClient } from "swan-public-api-client";
import { PapiClientConsumer } from "../Api/PapiClient";

interface PushStream {
  start: () => void;
  stop: () => void;
}

interface SubscriptionLifecycleState<T> {
  subscription: PushStream | undefined;
}

interface Props {
  papiSubscribe: (client: SwanPublicClient, groupKey: string) => PushStream;
  client: SwanPublicClient;
  groupKey: string;
}

class ContextStateToProp<T> extends React.PureComponent<
  Props,
  SubscriptionLifecycleState<T>
> {
  constructor(props: Props) {
    super(props);
    this.state = { subscription: undefined };
  }
  public componentDidMount() {
    const subscription = this.startSubscription(this.props.client);
    this.setState({
      subscription
    });
  }
  public componentDidUpdate(prevProps: Props) {
    if (prevProps.groupKey !== this.props.groupKey) {
      this.stopSubscription();
      const subscription = this.startSubscription(this.props.client);
      this.setState({
        subscription
      });
    }
  }
  public componentWillUnmount() {
    this.stopSubscription();
  }
  public render() {
    return this.props.children;
  }
  private stopSubscription() {
    if (this.state.subscription) {
      this.state.subscription.stop();
    }
  }
  private startSubscription(client: SwanPublicClient) {
    const subscription = this.props.papiSubscribe(client, this.props.groupKey);
    subscription.start();
    return subscription;
  }
}

interface SubscriptionLifecycleProps {
  groupKey: string;
  papiSubscribe: (client: SwanPublicClient, groupKey: string) => PushStream;
  children: () => JSX.Element;
}

// tslint:disable-next-line:max-classes-per-file
export class SubscriptionLifecycle<T> extends React.PureComponent<
  SubscriptionLifecycleProps
> {
  constructor(props: SubscriptionLifecycleProps) {
    super(props);
    this.state = {
      subscription: undefined
    };
  }
  public render() {
    return (
      <PapiClientConsumer>
        {state => {
          return (
            <ContextStateToProp
              client={state.client}
              papiSubscribe={this.props.papiSubscribe}
              groupKey={this.props.groupKey}
            >
              {this.props.children()}
            </ContextStateToProp>
          );
        }}
      </PapiClientConsumer>
    );
  }
}
